import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';

// Routes

import { moveFile, uploadFile } from '../../../../../routes/doctor/files';

// Redux 

import { selectFile, setCurrentFolder, setMode, setRefreshFileExplorer, setSearchSection } from '../../../../../redux/features/doctor/Dashboard/documents/fileExplorer';
import { setNotificationMessage } from '../../../../../redux/features/general/notification';
import { setEditedFileTitle } from '../../../../../redux/features/doctor/Dashboard/documents/editFile';
import { resetEditFile } from '../../../../../redux/features/doctor/Dashboard/documents/editFile';

// Components 

import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import FolderIcon from '@mui/icons-material/Folder';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';


const MoveFile: React.FC = () => {

    const { t } = useTranslation();
    const dispatch = useAppDispatch(); 

    const colors = useAppSelector(state => state.theme.colors);

    const directory = useAppSelector(state => state.fileExplorer.directory); 
    const selectedFile = useAppSelector(state => state.fileExplorer.selectedFile); 
    const currentFolder = useAppSelector(state => state.fileExplorer.currentFolder); 

    const accountInfo = useAppSelector(state => state.meta.accountInfo); 

    const editedFileTitle = useAppSelector((state) => state.editFile.title); 

    const [text, setText] = useState(''); 
    const [titleError, setTitleError] = useState(''); 
    const [path, setPath] = useState(''); 

    const [isTransferAllowed, setIsTransferAllowed] = useState(false); 

    // -- 

    const handleUnSelection = () => { 

        dispatch(setMode(''));
        dispatch(setSearchSection(selectedFile.folder));
        dispatch(selectFile(null));
        dispatch(resetEditFile()); 

    }; 

    // -- 

    const handleFileTransfer = async () => { 

        const res = await moveFile(selectedFile._id, currentFolder._id);  

        if (res?.data.status === 200) {

            dispatch(setCurrentFolder(res.data.folder)); 
            dispatch(setRefreshFileExplorer(true)); 
            dispatch(setNotificationMessage(t('fileMoved')));
            dispatch(selectFile(null)); 
            dispatch(setMode(''));
            dispatch(resetEditFile());

        } else if (res?.data.status === 401) {

            if (res?.data.error === 'invalidTitle') { 

                setTitleError(String(t('invalidTitle'))); 

            } else if (res?.data.error === 'existingFile') { 

                setTitleError(String(t('existingFile'))); 

            }; 

        };

    }; 

    // -- 

    useEffect(() => { 

        if (currentFolder) { 

            if (currentFolder.uploadedBy != accountInfo._id) { 

                setIsTransferAllowed(false); 

            } else if (currentFolder._id == selectedFile.folder) { 

                setIsTransferAllowed(false); 

            } else if ((currentFolder.path === 'Recent') || (currentFolder.path === 'Patients') || (currentFolder.path === 'Shared')) { 

                setIsTransferAllowed(false); 

            } else { 

                setIsTransferAllowed(true); 

            }; 

        } else { 

            setIsTransferAllowed(false); 

        }; 


    },[currentFolder]); 

    // -- 

    useEffect(() => { 

        if (text) { 

            dispatch(setEditedFileTitle(text)); 

        };

    },[text]); 

    // -- 

    useEffect(() => { 

        if (selectedFile) { 

            setText(selectedFile.title); 

        }; 

    },[selectedFile]); 
    
    // -- 

    return (

        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'row',
            alignItems: 'center', 
            width: '100%',
            height: 60, 
        }}>

            <Box
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'row',
                    alignItems: 'center', 
                    width: '28%',
                    marginLeft: '2%', 
                    padding: 1,
                    borderRadius: 2,
                    backgroundColor: colors?.fileExplorerFooter
                }}
            >
                <FolderIcon sx={{ color: colors?.folder, fontSize: 15, marginLeft: 1 }} />

                <Box 
                    sx={{
                        fontSize: 12, 
                        marginLeft: 3
                    }}>
                    {currentFolder.path}
                </Box>

            </Box>


            <Box
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'row',
                    alignItems: 'center', 
                    width: '30%',
                }}
            >
                <InsertDriveFileIcon sx={{ color: colors?.driveIcon, fontSize: 15, marginLeft: 5 }} />

                <TextField
                    variant="standard"
                    value={text}
                    error={titleError ? true : false}
                    helperText={titleError}
                    InputProps={{
                        style: {fontSize: 12, color: colors?.text },
                        disableUnderline: true, 
                    }}
                    onChange={(e) => setText(e.target.value)}
                    sx={{
                        marginLeft: 2,
                        fontSize: 12,
                        width: '80%'
                    }}
                />

            </Box>



            <Box style={{ 
                display: 'flex', 
                flexDirection: 'row-reverse',
                alignItems: 'center',  
                width: '40%',
            }}>

                <Button 
                    onClick={() => handleUnSelection()} 
                    sx={{ 
                        marginLeft: 1,
                        marginRight: 3,
                        color: colors?.closeButtonText, 
                        backgroundColor: colors?.closeButtonBackground,
                        borderColor: colors?.closeButtonBackground,
                        '&:hover': 
                        { 
                            backgroundColor: colors?.closeButtonBackground,
                            color: colors?.closeButtonText,
                            borderColor: colors?.closeButtonBackground
                        }
                    }}
                    variant="contained">{t('cancel')}
                </Button>

            { ((currentFolder?.path !== 'Recent') && (currentFolder?.path !== 'Patients') && (currentFolder?._id !== selectedFile?.folder)) ? 
                <Button onClick={() => handleFileTransfer()} sx={{ marginLeft: 5 }} variant="contained">{t('moveFile')}</Button>: 
                <Button 
                disabled={true}
                sx={{ 
                    backgroundColor: 'transparent',
                    borderColor: 'lightblue',
                    marginLeft: 5
                }}
                variant="outlined">{t('moveFile')}</Button>}
                    
                </Box>

        </Box>

    );

};

export default MoveFile;